<div class="min-h-screen h-screen bg-gray-50 flex">
  <app-sidebar [isOpen]="sidebarVisible"></app-sidebar>

  <div class="flex-1 flex flex-col">
    <!-- Header -->
    <header class="bg-white shadow-sm border-gray-50">
      <div class="px-6 py-4 flex items-center justify-between">
        <button
          (click)="toggleSidebar()"
          class="text-gray-600 hover:text-gray-900 transition-colors"
        >
          <i class="pi pi-bars text-xl"></i>
        </button>

        <div class="flex items-center space-x-4">
          <span class="text-sm text-gray-600">Bem-vindo, {{userName}}</span>
          <button
            (click)="logout()"
            class="flex cursor-pointer items-center space-x-2 text-gray-600 hover:text-red-600 transition-colors"
          >
            <i class="pi pi-sign-out text-base"></i>
            <span class="text-sm">Sair</span>
          </button>
        </div>
      </div>
    </header>

    <!-- Conteúdo principal -->
    <main class="flex-1 min-h-0 overflow-y-auto p-0">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>